module.exports = __webpack_public_path__ + "static/media/aws-certified-solutions-architect-associate.cee2983a.png";